import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// ============================================================================
// TIẾN TRÌNH UPLOAD FILE / ẢNH / AUDIO TRONG CHAT
//
// Tách RIÊNG phần trăm ra slice này thay vì nhét vào object tin nhắn: onUploadProgress
// của axios bắn rất dày (mỗi chunk một lần), nếu cập nhật vào danh sách tin nhắn thì
// toàn bộ khung chat re-render theo. Ở đây chỉ component thanh tiến trình (đọc qua
// useUploadProgress) re-render.
//
// Khóa là message_id do client sinh ra và gửi kèm khi upload — backend dùng LẠI đúng
// message_id đó (chat/src/services/chatv2.service.js), nên tin nhắn thật trả về sẽ
// thay thế đúng tin nhắn ảo trong danh sách.
// ============================================================================

export type UploadStatus = 'uploading' | 'error';

export interface UploadProgress {
  percent: number;
  status: UploadStatus;
  error?: string;
}

type UploadState = Record<string, UploadProgress>;

const initialState: UploadState = {};

const uploadSlice = createSlice({
  name: 'upload',
  initialState,
  reducers: {
    startUpload: (state, action: PayloadAction<{ messageId: string }>) => {
      state[action.payload.messageId] = { percent: 0, status: 'uploading' };
    },
    setUploadProgress: (state, action: PayloadAction<{ messageId: string; percent: number }>) => {
      const item = state[action.payload.messageId];
      if (item && item.status === 'uploading') {
        item.percent = action.payload.percent;
      }
    },
    setUploadError: (state, action: PayloadAction<{ messageId: string; error: string }>) => {
      const item = state[action.payload.messageId];
      if (item) {
        item.status = 'error';
        item.error = action.payload.error;
      } else {
        state[action.payload.messageId] = { percent: 0, status: 'error', error: action.payload.error };
      }
    },
    clearUpload: (state, action: PayloadAction<string>) => {
      delete state[action.payload];
    },
  },
});

export const { startUpload, setUploadProgress, setUploadError, clearUpload } = uploadSlice.actions;

export default uploadSlice.reducer;
